@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(451_683_317)
internal val Res.string.exp_content_vocab_vso_1_nilo: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_1_nilo", "exp_content_vocab_vso_1_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150800, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148124, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150433, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142464, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139164, 108),
      ))
    }

@delegate:ResourceContentHash(-1_486_776_620)
internal val Res.string.exp_content_vocab_vso_2_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_2_alyn", "exp_content_vocab_vso_2_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150917, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148265, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150554, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142585, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139273, 68),
      ))
    }

@delegate:ResourceContentHash(1_802_263_948)
internal val Res.string.exp_content_vocab_vso_2_nilo: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_2_nilo", "exp_content_vocab_vso_2_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 150994, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148334, 176),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150619, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142658, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139342, 124),
      ))
    }

@delegate:ResourceContentHash(1_326_447_067)
internal val Res.string.exp_content_vocab_vso_3_alyn: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_3_alyn", "exp_content_vocab_vso_3_alyn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151135, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148511, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150784, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142807, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139467, 104),
      ))
    }

@delegate:ResourceContentHash(-126_432_137)
internal val Res.string.exp_content_vocab_vso_3_nilo: StringResource by lazy {
      StringResource("string:exp_content_vocab_vso_3_nilo", "exp_content_vocab_vso_3_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151244, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148636, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 150909, 152),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 142916, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139572, 132),
      ))
    }

@delegate:ResourceContentHash(938_669_802)
internal val Res.string.exp_content_word_reading_and_meaning: StringResource by lazy {
      StringResource("string:exp_content_word_reading_and_meaning", "exp_content_word_reading_and_meaning", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151385, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148789, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151062, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143057, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139705, 104),
      ))
    }

@delegate:ResourceContentHash(1_476_864_292)
internal val Res.string.exp_title_aggettivi_genere: StringResource by lazy {
      StringResource("string:exp_title_aggettivi_genere", "exp_title_aggettivi_genere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151502, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148898, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151167, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143170, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139810, 66),
      ))
    }

@delegate:ResourceContentHash(-427_201_491)
internal val Res.string.exp_title_aggettivi_plurale: StringResource by lazy {
      StringResource("string:exp_title_aggettivi_plurale", "exp_title_aggettivi_plurale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151569, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 148957, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151222, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143225, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139877, 55),
      ))
    }

@delegate:ResourceContentHash(562_574_339)
internal val Res.string.exp_title_aggettivo_sostantivato: StringResource by lazy {
      StringResource("string:exp_title_aggettivo_sostantivato", "exp_title_aggettivo_sostantivato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151621, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149013, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151290, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143281, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 139933, 76),
      ))
    }

@delegate:ResourceContentHash(-1_781_210_298)
internal val Res.string.exp_title_altri_plurali: StringResource by lazy {
      StringResource("string:exp_title_altri_plurali", "exp_title_altri_plurali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151694, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149082, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151355, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143350, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140010, 51),
      ))
    }

@delegate:ResourceContentHash(-723_257_991)
internal val Res.string.exp_title_amare: StringResource by lazy {
      StringResource("string:exp_title_amare", "exp_title_amare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151746, 31),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149134, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151407, 31),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143402, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140062, 31),
      ))
    }

@delegate:ResourceContentHash(1_781_644_233)
internal val Res.string.exp_title_andare_a_capo: StringResource by lazy {
      StringResource("string:exp_title_andare_a_capo", "exp_title_andare_a_capo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151778, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149166, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151439, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143434, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140094, 59),
      ))
    }

@delegate:ResourceContentHash(397_607_989)
internal val Res.string.exp_title_apposizione: StringResource by lazy {
      StringResource("string:exp_title_apposizione", "exp_title_apposizione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151834, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149222, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151495, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143486, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140154, 45),
      ))
    }

@delegate:ResourceContentHash(-1_159_194_324)
internal val Res.string.exp_title_ascoltare: StringResource by lazy {
      StringResource("string:exp_title_ascoltare", "exp_title_ascoltare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151880, 35),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149268, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151541, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143532, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140200, 35),
      ))
    }

@delegate:ResourceContentHash(1_165_189_343)
internal val Res.string.exp_title_bere: StringResource by lazy {
      StringResource("string:exp_title_bere", "exp_title_bere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151916, 34),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149308, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151581, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143572, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140236, 30),
      ))
    }

@delegate:ResourceContentHash(-1_415_495_696)
internal val Res.string.exp_title_calibratura: StringResource by lazy {
      StringResource("string:exp_title_calibratura", "exp_title_calibratura", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151951, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149339, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151612, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143603, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140267, 45),
      ))
    }

@delegate:ResourceContentHash(1_359_562_016)
internal val Res.string.exp_title_cambio_di_rotta: StringResource by lazy {
      StringResource("string:exp_title_cambio_di_rotta", "exp_title_cambio_di_rotta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 151997, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149381, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151654, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143649, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140313, 57),
      ))
    }

@delegate:ResourceContentHash(376_889_593)
internal val Res.string.exp_title_cartigli: StringResource by lazy {
      StringResource("string:exp_title_cartigli", "exp_title_cartigli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152047, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149435, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151712, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143703, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140371, 42),
      ))
    }

@delegate:ResourceContentHash(-937_678_932)
internal val Res.string.exp_title_casa_uscire: StringResource by lazy {
      StringResource("string:exp_title_casa_uscire", "exp_title_casa_uscire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152090, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149474, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151755, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143742, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140414, 53),
      ))
    }

@delegate:ResourceContentHash(1_259_308_544)
internal val Res.string.exp_title_chap5_intro: StringResource by lazy {
      StringResource("string:exp_title_chap5_intro", "exp_title_chap5_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152144, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149520, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151805, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143792, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140468, 57),
      ))
    }

@delegate:ResourceContentHash(-1_404_962_349)
internal val Res.string.exp_title_classi_verbali: StringResource by lazy {
      StringResource("string:exp_title_classi_verbali", "exp_title_classi_verbali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152210, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149586, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151875, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143854, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140526, 52),
      ))
    }

@delegate:ResourceContentHash(1_976_733_309)
internal val Res.string.exp_title_come_distinguere: StringResource by lazy {
      StringResource("string:exp_title_come_distinguere", "exp_title_come_distinguere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152263, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149639, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151932, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143907, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140579, 62),
      ))
    }

@delegate:ResourceContentHash(153_328_204)
internal val Res.string.exp_title_complementi_complessi: StringResource by lazy {
      StringResource("string:exp_title_complementi_complessi", "exp_title_complementi_complessi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152330, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149702, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 151995, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 143966, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140642, 59),
      ))
    }

@delegate:ResourceContentHash(638_044_674)
internal val Res.string.exp_title_complemento_oggetto: StringResource by lazy {
      StringResource("string:exp_title_complemento_oggetto", "exp_title_complemento_oggetto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152394, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149774, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152059, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144034, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140702, 57),
      ))
    }

@delegate:ResourceContentHash(-12_716_690)
internal val Res.string.exp_title_dare: StringResource by lazy {
      StringResource("string:exp_title_dare", "exp_title_dare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152452, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149840, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152113, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144100, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140760, 30),
      ))
    }

@delegate:ResourceContentHash(-1_067_254_735)
internal val Res.string.exp_title_densit: StringResource by lazy {
      StringResource("string:exp_title_densit", "exp_title_densit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152483, 32),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149867, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152144, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144131, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140791, 36),
      ))
    }

@delegate:ResourceContentHash(733_464_643)
internal val Res.string.exp_title_dire: StringResource by lazy {
      StringResource("string:exp_title_dire", "exp_title_dire", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152571, 30),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149971, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152240, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144235, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140891, 26),
      ))
    }

@delegate:ResourceContentHash(430_945_319)
internal val Res.string.exp_title_direzione_di_lettura: StringResource by lazy {
      StringResource("string:exp_title_direzione_di_lettura", "exp_title_direzione_di_lettura", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152516, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 149904, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152181, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144168, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140828, 62),
      ))
    }

@delegate:ResourceContentHash(258_405_917)
internal val Res.string.exp_title_duat_oltretomba: StringResource by lazy {
      StringResource("string:exp_title_duat_oltretomba", "exp_title_duat_oltretomba", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152602, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150002, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152271, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144266, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140918, 57),
      ))
    }

@delegate:ResourceContentHash(-1_359_669_548)
internal val Res.string.exp_title_due_oggetti: StringResource by lazy {
      StringResource("string:exp_title_due_oggetti", "exp_title_due_oggetti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152656, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150060, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152329, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144324, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140976, 45),
      ))
    }

@delegate:ResourceContentHash(1_070_769_880)
internal val Res.string.exp_title_due_soggetti: StringResource by lazy {
      StringResource("string:exp_title_due_soggetti", "exp_title_due_soggetti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152702, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150106, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152375, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144370, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141022, 46),
      ))
    }

@delegate:ResourceContentHash(1_002_984_408)
internal val Res.string.exp_title_e_ora: StringResource by lazy {
      StringResource("string:exp_title_e_ora", "exp_title_e_ora", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152753, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150153, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152422, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144417, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141069, 35),
      ))
    }

@delegate:ResourceContentHash(1_050_986_472)
internal val Res.string.exp_title_ecco_fatto: StringResource by lazy {
      StringResource("string:exp_title_ecco_fatto", "exp_title_ecco_fatto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152793, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150193, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152466, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144449, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141105, 40),
      ))
    }

@delegate:ResourceContentHash(-627_545_898)
internal val Res.string.exp_title_end_verb_1: StringResource by lazy {
      StringResource("string:exp_title_end_verb_1", "exp_title_end_verb_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152838, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150234, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152511, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144494, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141146, 48),
      ))
    }

@delegate:ResourceContentHash(326_602_173)
internal val Res.string.exp_title_ending_vso: StringResource by lazy {
      StringResource("string:exp_title_ending_vso", "exp_title_ending_vso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152883, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150283, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152552, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144543, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141195, 52),
      ))
    }

@delegate:ResourceContentHash(41_688_904)
internal val Res.string.exp_title_entrare: StringResource by lazy {
      StringResource("string:exp_title_entrare", "exp_title_entrare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152944, 41),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150336, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152609, 33),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144596, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141248, 33),
      ))
    }

@delegate:ResourceContentHash(-1_348_626_761)
internal val Res.string.exp_title_esempio_1: StringResource by lazy {
      StringResource("string:exp_title_esempio_1", "exp_title_esempio_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 152986, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150370, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152643, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144634, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141282, 39),
      ))
    }

@delegate:ResourceContentHash(996_615_821)
internal val Res.string.exp_title_esempio_2: StringResource by lazy {
      StringResource("string:exp_title_esempio_2", "exp_title_esempio_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153030, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150410, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152683, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144674, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141322, 39),
      ))
    }

@delegate:ResourceContentHash(340_709_747)
internal val Res.string.exp_title_esempio_la_parola_balia: StringResource by lazy {
      StringResource("string:exp_title_esempio_la_parola_balia", "exp_title_esempio_la_parola_balia", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153074, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150450, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152723, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144714, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141362, 73),
      ))
    }

@delegate:ResourceContentHash(869_043_870)
internal val Res.string.exp_title_esempio_padre_it: StringResource by lazy {
      StringResource("string:exp_title_esempio_padre_it", "exp_title_esempio_padre_it", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153148, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150528, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152801, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144788, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141436, 66),
      ))
    }

@delegate:ResourceContentHash(-153_090_481)
internal val Res.string.exp_title_esempio_pratico: StringResource by lazy {
      StringResource("string:exp_title_esempio_pratico", "exp_title_esempio_pratico", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153215, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150591, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152868, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144851, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141503, 57),
      ))
    }

@delegate:ResourceContentHash(2_096_775_179)
internal val Res.string.exp_title_esempio_uomo_rmt: StringResource by lazy {
      StringResource("string:exp_title_esempio_uomo_rmt", "exp_title_esempio_uomo_rmt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153277, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150649, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152926, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144905, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141561, 66),
      ))
    }

@delegate:ResourceContentHash(-342_397_381)
internal val Res.string.exp_title_esistere_essere: StringResource by lazy {
      StringResource("string:exp_title_esistere_essere", "exp_title_esistere_essere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153344, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150720, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 152997, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 144972, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141628, 53),
      ))
    }

@delegate:ResourceContentHash(904_433_236)
internal val Res.string.exp_title_eternit: StringResource by lazy {
      StringResource("string:exp_title_eternit", "exp_title_eternit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153402, 37),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150774, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153051, 41),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145030, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141682, 37),
      ))
    }

@delegate:ResourceContentHash(1_058_141_678)
internal val Res.string.exp_title_eureka: StringResource by lazy {
      StringResource("string:exp_title_eureka", "exp_title_eureka", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153440, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150812, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153093, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145068, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141720, 36),
      ))
    }

@delegate:ResourceContentHash(137_665_261)
internal val Res.string.exp_title_facciamo_il_punto: StringResource by lazy {
      StringResource("string:exp_title_facciamo_il_punto", "exp_title_facciamo_il_punto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153477, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150849, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153130, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145105, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141757, 51),
      ))
    }

@delegate:ResourceContentHash(-959_326_221)
internal val Res.string.exp_title_fare: StringResource by lazy {
      StringResource("string:exp_title_fare", "exp_title_fare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153533, 26),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150909, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153190, 30),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145165, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141809, 26),
      ))
    }

@delegate:ResourceContentHash(-1_246_264_385)
internal val Res.string.exp_title_formare_verbi: StringResource by lazy {
      StringResource("string:exp_title_formare_verbi", "exp_title_formare_verbi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153756, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151136, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153417, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145392, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142032, 47),
      ))
    }

@delegate:ResourceContentHash(-2_022_756_799)
internal val Res.string.exp_title_formare_verbi_2_lit: StringResource by lazy {
      StringResource("string:exp_title_formare_verbi_2_lit", "exp_title_formare_verbi_2_lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153560, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150940, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153221, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145196, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141836, 45),
      ))
    }

@delegate:ResourceContentHash(-1_448_919_928)
internal val Res.string.exp_title_formare_verbi_2ae_gem: StringResource by lazy {
      StringResource("string:exp_title_formare_verbi_2ae_gem", "exp_title_formare_verbi_2ae_gem", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153606, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 150986, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153267, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145242, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141882, 51),
      ))
    }

@delegate:ResourceContentHash(722_394_705)
internal val Res.string.exp_title_formare_verbi_3_lit: StringResource by lazy {
      StringResource("string:exp_title_formare_verbi_3_lit", "exp_title_formare_verbi_3_lit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153658, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151038, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153319, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145294, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141934, 45),
      ))
    }

@delegate:ResourceContentHash(-1_762_711_252)
internal val Res.string.exp_title_formare_verbi_3ae_inf: StringResource by lazy {
      StringResource("string:exp_title_formare_verbi_3ae_inf", "exp_title_formare_verbi_3ae_inf", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153704, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151084, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153365, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145340, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 141980, 51),
      ))
    }

@delegate:ResourceContentHash(-1_341_712_250)
internal val Res.string.exp_title_frasi_avverbiali: StringResource by lazy {
      StringResource("string:exp_title_frasi_avverbiali", "exp_title_frasi_avverbiali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153804, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151184, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153465, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145440, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142080, 62),
      ))
    }

@delegate:ResourceContentHash(663_215_242)
internal val Res.string.exp_title_frasi_con_pronomi: StringResource by lazy {
      StringResource("string:exp_title_frasi_con_pronomi", "exp_title_frasi_con_pronomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153859, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151255, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153528, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145503, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142143, 67),
      ))
    }

@delegate:ResourceContentHash(-1_696_478_058)
internal val Res.string.exp_title_frasi_con_soggetto: StringResource by lazy {
      StringResource("string:exp_title_frasi_con_soggetto", "exp_title_frasi_con_soggetto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153923, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151323, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153592, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145563, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142211, 68),
      ))
    }

@delegate:ResourceContentHash(-2_022_828_983)
internal val Res.string.exp_title_genere: StringResource by lazy {
      StringResource("string:exp_title_genere", "exp_title_genere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 153984, 28),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151388, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153653, 32),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145624, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142280, 32),
      ))
    }

@delegate:ResourceContentHash(410_431_877)
internal val Res.string.exp_title_genitivo_diretto: StringResource by lazy {
      StringResource("string:exp_title_genitivo_diretto", "exp_title_genitivo_diretto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154079, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151491, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153748, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145723, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142375, 54),
      ))
    }

@delegate:ResourceContentHash(1_972_747_867)
internal val Res.string.exp_title_genitivo_diretto_ii: StringResource by lazy {
      StringResource("string:exp_title_genitivo_diretto_ii", "exp_title_genitivo_diretto_ii", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154013, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151425, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153686, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145657, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142313, 61),
      ))
    }

@delegate:ResourceContentHash(-1_241_796_117)
internal val Res.string.exp_title_genitivo_indiretto_i: StringResource by lazy {
      StringResource("string:exp_title_genitivo_indiretto_i", "exp_title_genitivo_indiretto_i", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154206, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151618, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153871, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145850, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142498, 66),
      ))
    }

@delegate:ResourceContentHash(-1_194_779_285)
internal val Res.string.exp_title_genitivo_indiretto_ii: StringResource by lazy {
      StringResource("string:exp_title_genitivo_indiretto_ii", "exp_title_genitivo_indiretto_ii", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154138, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151550, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153803, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145782, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142430, 67),
      ))
    }

@delegate:ResourceContentHash(-1_392_694_779)
internal val Res.string.exp_title_geroglifici_animali: StringResource by lazy {
      StringResource("string:exp_title_geroglifici_animali", "exp_title_geroglifici_animali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154273, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151685, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 153938, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145917, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142565, 69),
      ))
    }

@delegate:ResourceContentHash(-2_050_388_504)
internal val Res.string.exp_title_geroglifici_cibo: StringResource by lazy {
      StringResource("string:exp_title_geroglifici_cibo", "exp_title_geroglifici_cibo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154339, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151755, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154008, 70),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 145983, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142635, 62),
      ))
    }

@delegate:ResourceContentHash(1_291_871_947)
internal val Res.string.exp_title_geroglifici_umani_e_ruoli: StringResource by lazy {
      StringResource("string:exp_title_geroglifici_umani_e_ruoli", "exp_title_geroglifici_umani_e_ruoli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154402, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151818, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154079, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146042, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142698, 87),
      ))
    }

@delegate:ResourceContentHash(1_460_783_151)
internal val Res.string.exp_title_gli_ideogrammi: StringResource by lazy {
      StringResource("string:exp_title_gli_ideogrammi", "exp_title_gli_ideogrammi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154490, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151902, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154167, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146122, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142786, 52),
      ))
    }

@delegate:ResourceContentHash(852_884_726)
internal val Res.string.exp_title_hiero_dei_sovrani_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_dei_sovrani_intro", "exp_title_hiero_dei_sovrani_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154543, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 151955, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154224, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146175, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142839, 65),
      ))
    }

@delegate:ResourceContentHash(1_323_760_862)
internal val Res.string.exp_title_hiero_famiglia_societa_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_famiglia_societa_intro", "exp_title_hiero_famiglia_societa_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154621, 94),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152033, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154306, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146249, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142905, 82),
      ))
    }

@delegate:ResourceContentHash(-1_566_171_386)
internal val Res.string.exp_title_hiero_oggetti_sacri_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_oggetti_sacri_intro", "exp_title_hiero_oggetti_sacri_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154716, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152120, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154405, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146336, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 142988, 91),
      ))
    }

@delegate:ResourceContentHash(1_162_021_212)
internal val Res.string.exp_title_hiero_vari_1: StringResource by lazy {
      StringResource("string:exp_title_hiero_vari_1", "exp_title_hiero_vari_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154812, 74),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152216, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154505, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146424, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143080, 66),
      ))
    }

@delegate:ResourceContentHash(1_324_516_252)
internal val Res.string.exp_title_hiero_vari_2: StringResource by lazy {
      StringResource("string:exp_title_hiero_vari_2", "exp_title_hiero_vari_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154887, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152291, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154572, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146491, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143147, 66),
      ))
    }

@delegate:ResourceContentHash(751_190_597)
internal val Res.string.exp_title_hiero_verbi_vari_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_verbi_vari_intro", "exp_title_hiero_verbi_vari_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 154966, 68),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152366, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154639, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146562, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143214, 64),
      ))
    }

@delegate:ResourceContentHash(-2_012_188_100)
internal val Res.string.exp_title_hiero_verbs_1_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_verbs_1_intro", "exp_title_hiero_verbs_1_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155035, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152439, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154716, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146631, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143279, 77),
      ))
    }

@delegate:ResourceContentHash(327_129_942)
internal val Res.string.exp_title_hiero_verbs_2_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_verbs_2_intro", "exp_title_hiero_verbs_2_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155117, 81),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152525, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154798, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146709, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143357, 69),
      ))
    }

@delegate:ResourceContentHash(-404_857_634)
internal val Res.string.exp_title_hiero_verbs_3_intro: StringResource by lazy {
      StringResource("string:exp_title_hiero_verbs_3_intro", "exp_title_hiero_verbs_3_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155199, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152603, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154876, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146783, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143427, 65),
      ))
    }

@delegate:ResourceContentHash(-259_487_468)
internal val Res.string.exp_title_hiero_vso_1: StringResource by lazy {
      StringResource("string:exp_title_hiero_vso_1", "exp_title_hiero_vso_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155269, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152673, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 154950, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146849, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143493, 73),
      ))
    }

@delegate:ResourceContentHash(106_039_100)
internal val Res.string.exp_title_hiero_vso_2: StringResource by lazy {
      StringResource("string:exp_title_hiero_vso_2", "exp_title_hiero_vso_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155347, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152751, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155028, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146923, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143567, 73),
      ))
    }

@delegate:ResourceContentHash(-744_871_180)
internal val Res.string.exp_title_hiero_vso_3: StringResource by lazy {
      StringResource("string:exp_title_hiero_vso_3", "exp_title_hiero_vso_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155433, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152833, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155110, 73),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 146997, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143641, 69),
      ))
    }

@delegate:ResourceContentHash(1_918_191_888)
internal val Res.string.exp_title_i_complementi_fonetici: StringResource by lazy {
      StringResource("string:exp_title_i_complementi_fonetici", "exp_title_i_complementi_fonetici", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155507, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152907, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155184, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147067, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143711, 68),
      ))
    }

@delegate:ResourceContentHash(1_525_186_707)
internal val Res.string.exp_title_i_determinativi: StringResource by lazy {
      StringResource("string:exp_title_i_determinativi", "exp_title_i_determinativi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155580, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 152984, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155261, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147140, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143780, 57),
      ))
    }

@delegate:ResourceContentHash(1_375_928_637)
internal val Res.string.exp_title_i_fonogrammi: StringResource by lazy {
      StringResource("string:exp_title_i_fonogrammi", "exp_title_i_fonogrammi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155638, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153042, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155319, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147194, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143838, 50),
      ))
    }

@delegate:ResourceContentHash(664_391_096)
internal val Res.string.exp_title_i_tipi_di_segni: StringResource by lazy {
      StringResource("string:exp_title_i_tipi_di_segni", "exp_title_i_tipi_di_segni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155689, 61),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153093, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155374, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147241, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143889, 57),
      ))
    }

@delegate:ResourceContentHash(-1_638_907_370)
internal val Res.string.exp_title_il_dimostrativo_pn: StringResource by lazy {
      StringResource("string:exp_title_il_dimostrativo_pn", "exp_title_il_dimostrativo_pn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155751, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153155, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155436, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147295, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143947, 56),
      ))
    }

@delegate:ResourceContentHash(1_337_763_244)
internal val Res.string.exp_title_il_genitivo_diretto: StringResource by lazy {
      StringResource("string:exp_title_il_genitivo_diretto", "exp_title_il_genitivo_diretto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155812, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153212, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155493, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147352, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144004, 57),
      ))
    }

@delegate:ResourceContentHash(486_891_486)
internal val Res.string.exp_title_il_genitivo_indiretto: StringResource by lazy {
      StringResource("string:exp_title_il_genitivo_indiretto", "exp_title_il_genitivo_indiretto", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155878, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153278, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155551, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147418, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144062, 63),
      ))
    }

@delegate:ResourceContentHash(-1_608_490_824)
internal val Res.string.exp_title_il_grande_ritorno: StringResource by lazy {
      StringResource("string:exp_title_il_grande_ritorno", "exp_title_il_grande_ritorno", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 155946, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153346, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155615, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147486, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144126, 59),
      ))
    }

@delegate:ResourceContentHash(215_188_392)
internal val Res.string.exp_title_il_segreto_della_piramide: StringResource by lazy {
      StringResource("string:exp_title_il_segreto_della_piramide", "exp_title_il_segreto_della_piramide", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156010, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153402, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155671, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147546, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144186, 67),
      ))
    }

@delegate:ResourceContentHash(-2_144_432_384)
internal val Res.string.exp_title_il_tema_verbale_sdm_f: StringResource by lazy {
      StringResource("string:exp_title_il_tema_verbale_sdm_f", "exp_title_il_tema_verbale_sdm_f", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156090, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153474, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155751, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147622, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144254, 67),
      ))
    }

@delegate:ResourceContentHash(-1_058_542_234)
internal val Res.string.exp_title_il_verbo_ma_i: StringResource by lazy {
      StringResource("string:exp_title_il_verbo_ma_i", "exp_title_il_verbo_ma_i", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156158, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153542, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155823, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147690, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144322, 51),
      ))
    }

@delegate:ResourceContentHash(-158_260_677)
internal val Res.string.exp_title_in_viaggio_sul_nilo: StringResource by lazy {
      StringResource("string:exp_title_in_viaggio_sul_nilo", "exp_title_in_viaggio_sul_nilo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156206, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153594, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155871, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147738, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144374, 49),
      ))
    }

@delegate:ResourceContentHash(-588_172_161)
internal val Res.string.exp_title_intro_vso: StringResource by lazy {
      StringResource("string:exp_title_intro_vso", "exp_title_intro_vso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156306, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153694, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155975, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147838, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144470, 51),
      ))
    }

@delegate:ResourceContentHash(-1_102_918_196)
internal val Res.string.exp_title_intro_vso_8: StringResource by lazy {
      StringResource("string:exp_title_intro_vso_8", "exp_title_intro_vso_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156260, 45),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153648, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 155929, 45),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147792, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144424, 45),
      ))
    }

@delegate:ResourceContentHash(-421_884_875)
internal val Res.string.exp_title_introduzione: StringResource by lazy {
      StringResource("string:exp_title_introduzione", "exp_title_introduzione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156350, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153738, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156023, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147882, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144522, 46),
      ))
    }

@delegate:ResourceContentHash(1_245_237_780)
internal val Res.string.exp_title_investighiamo: StringResource by lazy {
      StringResource("string:exp_title_investighiamo", "exp_title_investighiamo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156397, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153789, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156070, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147929, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144569, 55),
      ))
    }

@delegate:ResourceContentHash(1_223_309_737)
internal val Res.string.exp_title_iunu_heliopolis: StringResource by lazy {
      StringResource("string:exp_title_iunu_heliopolis", "exp_title_iunu_heliopolis", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156449, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153845, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156118, 61),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 147981, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144625, 57),
      ))
    }

@delegate:ResourceContentHash(-511_602_560)
internal val Res.string.exp_title_l_infinito: StringResource by lazy {
      StringResource("string:exp_title_l_infinito", "exp_title_l_infinito", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156507, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153903, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156180, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148039, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144683, 48),
      ))
    }

@delegate:ResourceContentHash(-1_102_918_196)
internal val Res.string.exp_title_la_forma_vso: StringResource by lazy {
      StringResource("string:exp_title_la_forma_vso", "exp_title_la_forma_vso", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156556, 46),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153952, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156225, 46),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148084, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144732, 46),
      ))
    }

@delegate:ResourceContentHash(-693_275_093)
internal val Res.string.exp_title_la_frase_misteriosa: StringResource by lazy {
      StringResource("string:exp_title_la_frase_misteriosa", "exp_title_la_frase_misteriosa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156603, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 153999, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156272, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148131, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144779, 69),
      ))
    }

@delegate:ResourceContentHash(1_362_839_384)
internal val Res.string.exp_title_la_particella_ni: StringResource by lazy {
      StringResource("string:exp_title_la_particella_ni", "exp_title_la_particella_ni", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156673, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154065, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156342, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148197, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144849, 46),
      ))
    }

@delegate:ResourceContentHash(1_824_085_238)
internal val Res.string.exp_title_la_pazienza_e_finita: StringResource by lazy {
      StringResource("string:exp_title_la_pazienza_e_finita", "exp_title_la_pazienza_e_finita", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156732, 70),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154128, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156401, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148256, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144896, 66),
      ))
    }

@delegate:ResourceContentHash(-1_154_579_577)
internal val Res.string.exp_title_la_teoria: StringResource by lazy {
      StringResource("string:exp_title_la_teoria", "exp_title_la_teoria", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156803, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154207, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156476, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148323, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144963, 35),
      ))
    }

@delegate:ResourceContentHash(-2_011_308_783)
internal val Res.string.exp_title_le_frasi_avverbiali: StringResource by lazy {
      StringResource("string:exp_title_le_frasi_avverbiali", "exp_title_le_frasi_avverbiali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 156847, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 154251, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 156516, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 148363, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 144999, 65),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString13Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_vocab_vso_1_nilo", Res.string.exp_content_vocab_vso_1_nilo)
  map.put("exp_content_vocab_vso_2_alyn", Res.string.exp_content_vocab_vso_2_alyn)
  map.put("exp_content_vocab_vso_2_nilo", Res.string.exp_content_vocab_vso_2_nilo)
  map.put("exp_content_vocab_vso_3_alyn", Res.string.exp_content_vocab_vso_3_alyn)
  map.put("exp_content_vocab_vso_3_nilo", Res.string.exp_content_vocab_vso_3_nilo)
  map.put("exp_content_word_reading_and_meaning", Res.string.exp_content_word_reading_and_meaning)
  map.put("exp_title_aggettivi_genere", Res.string.exp_title_aggettivi_genere)
  map.put("exp_title_aggettivi_plurale", Res.string.exp_title_aggettivi_plurale)
  map.put("exp_title_aggettivo_sostantivato", Res.string.exp_title_aggettivo_sostantivato)
  map.put("exp_title_altri_plurali", Res.string.exp_title_altri_plurali)
  map.put("exp_title_amare", Res.string.exp_title_amare)
  map.put("exp_title_andare_a_capo", Res.string.exp_title_andare_a_capo)
  map.put("exp_title_apposizione", Res.string.exp_title_apposizione)
  map.put("exp_title_ascoltare", Res.string.exp_title_ascoltare)
  map.put("exp_title_bere", Res.string.exp_title_bere)
  map.put("exp_title_calibratura", Res.string.exp_title_calibratura)
  map.put("exp_title_cambio_di_rotta", Res.string.exp_title_cambio_di_rotta)
  map.put("exp_title_cartigli", Res.string.exp_title_cartigli)
  map.put("exp_title_casa_uscire", Res.string.exp_title_casa_uscire)
  map.put("exp_title_chap5_intro", Res.string.exp_title_chap5_intro)
  map.put("exp_title_classi_verbali", Res.string.exp_title_classi_verbali)
  map.put("exp_title_come_distinguere", Res.string.exp_title_come_distinguere)
  map.put("exp_title_complementi_complessi", Res.string.exp_title_complementi_complessi)
  map.put("exp_title_complemento_oggetto", Res.string.exp_title_complemento_oggetto)
  map.put("exp_title_dare", Res.string.exp_title_dare)
  map.put("exp_title_densit", Res.string.exp_title_densit)
  map.put("exp_title_dire", Res.string.exp_title_dire)
  map.put("exp_title_direzione_di_lettura", Res.string.exp_title_direzione_di_lettura)
  map.put("exp_title_duat_oltretomba", Res.string.exp_title_duat_oltretomba)
  map.put("exp_title_due_oggetti", Res.string.exp_title_due_oggetti)
  map.put("exp_title_due_soggetti", Res.string.exp_title_due_soggetti)
  map.put("exp_title_e_ora", Res.string.exp_title_e_ora)
  map.put("exp_title_ecco_fatto", Res.string.exp_title_ecco_fatto)
  map.put("exp_title_end_verb_1", Res.string.exp_title_end_verb_1)
  map.put("exp_title_ending_vso", Res.string.exp_title_ending_vso)
  map.put("exp_title_entrare", Res.string.exp_title_entrare)
  map.put("exp_title_esempio_1", Res.string.exp_title_esempio_1)
  map.put("exp_title_esempio_2", Res.string.exp_title_esempio_2)
  map.put("exp_title_esempio_la_parola_balia", Res.string.exp_title_esempio_la_parola_balia)
  map.put("exp_title_esempio_padre_it", Res.string.exp_title_esempio_padre_it)
  map.put("exp_title_esempio_pratico", Res.string.exp_title_esempio_pratico)
  map.put("exp_title_esempio_uomo_rmt", Res.string.exp_title_esempio_uomo_rmt)
  map.put("exp_title_esistere_essere", Res.string.exp_title_esistere_essere)
  map.put("exp_title_eternit", Res.string.exp_title_eternit)
  map.put("exp_title_eureka", Res.string.exp_title_eureka)
  map.put("exp_title_facciamo_il_punto", Res.string.exp_title_facciamo_il_punto)
  map.put("exp_title_fare", Res.string.exp_title_fare)
  map.put("exp_title_formare_verbi", Res.string.exp_title_formare_verbi)
  map.put("exp_title_formare_verbi_2_lit", Res.string.exp_title_formare_verbi_2_lit)
  map.put("exp_title_formare_verbi_2ae_gem", Res.string.exp_title_formare_verbi_2ae_gem)
  map.put("exp_title_formare_verbi_3_lit", Res.string.exp_title_formare_verbi_3_lit)
  map.put("exp_title_formare_verbi_3ae_inf", Res.string.exp_title_formare_verbi_3ae_inf)
  map.put("exp_title_frasi_avverbiali", Res.string.exp_title_frasi_avverbiali)
  map.put("exp_title_frasi_con_pronomi", Res.string.exp_title_frasi_con_pronomi)
  map.put("exp_title_frasi_con_soggetto", Res.string.exp_title_frasi_con_soggetto)
  map.put("exp_title_genere", Res.string.exp_title_genere)
  map.put("exp_title_genitivo_diretto", Res.string.exp_title_genitivo_diretto)
  map.put("exp_title_genitivo_diretto_ii", Res.string.exp_title_genitivo_diretto_ii)
  map.put("exp_title_genitivo_indiretto_i", Res.string.exp_title_genitivo_indiretto_i)
  map.put("exp_title_genitivo_indiretto_ii", Res.string.exp_title_genitivo_indiretto_ii)
  map.put("exp_title_geroglifici_animali", Res.string.exp_title_geroglifici_animali)
  map.put("exp_title_geroglifici_cibo", Res.string.exp_title_geroglifici_cibo)
  map.put("exp_title_geroglifici_umani_e_ruoli", Res.string.exp_title_geroglifici_umani_e_ruoli)
  map.put("exp_title_gli_ideogrammi", Res.string.exp_title_gli_ideogrammi)
  map.put("exp_title_hiero_dei_sovrani_intro", Res.string.exp_title_hiero_dei_sovrani_intro)
  map.put("exp_title_hiero_famiglia_societa_intro", Res.string.exp_title_hiero_famiglia_societa_intro)
  map.put("exp_title_hiero_oggetti_sacri_intro", Res.string.exp_title_hiero_oggetti_sacri_intro)
  map.put("exp_title_hiero_vari_1", Res.string.exp_title_hiero_vari_1)
  map.put("exp_title_hiero_vari_2", Res.string.exp_title_hiero_vari_2)
  map.put("exp_title_hiero_verbi_vari_intro", Res.string.exp_title_hiero_verbi_vari_intro)
  map.put("exp_title_hiero_verbs_1_intro", Res.string.exp_title_hiero_verbs_1_intro)
  map.put("exp_title_hiero_verbs_2_intro", Res.string.exp_title_hiero_verbs_2_intro)
  map.put("exp_title_hiero_verbs_3_intro", Res.string.exp_title_hiero_verbs_3_intro)
  map.put("exp_title_hiero_vso_1", Res.string.exp_title_hiero_vso_1)
  map.put("exp_title_hiero_vso_2", Res.string.exp_title_hiero_vso_2)
  map.put("exp_title_hiero_vso_3", Res.string.exp_title_hiero_vso_3)
  map.put("exp_title_i_complementi_fonetici", Res.string.exp_title_i_complementi_fonetici)
  map.put("exp_title_i_determinativi", Res.string.exp_title_i_determinativi)
  map.put("exp_title_i_fonogrammi", Res.string.exp_title_i_fonogrammi)
  map.put("exp_title_i_tipi_di_segni", Res.string.exp_title_i_tipi_di_segni)
  map.put("exp_title_il_dimostrativo_pn", Res.string.exp_title_il_dimostrativo_pn)
  map.put("exp_title_il_genitivo_diretto", Res.string.exp_title_il_genitivo_diretto)
  map.put("exp_title_il_genitivo_indiretto", Res.string.exp_title_il_genitivo_indiretto)
  map.put("exp_title_il_grande_ritorno", Res.string.exp_title_il_grande_ritorno)
  map.put("exp_title_il_segreto_della_piramide", Res.string.exp_title_il_segreto_della_piramide)
  map.put("exp_title_il_tema_verbale_sdm_f", Res.string.exp_title_il_tema_verbale_sdm_f)
  map.put("exp_title_il_verbo_ma_i", Res.string.exp_title_il_verbo_ma_i)
  map.put("exp_title_in_viaggio_sul_nilo", Res.string.exp_title_in_viaggio_sul_nilo)
  map.put("exp_title_intro_vso", Res.string.exp_title_intro_vso)
  map.put("exp_title_intro_vso_8", Res.string.exp_title_intro_vso_8)
  map.put("exp_title_introduzione", Res.string.exp_title_introduzione)
  map.put("exp_title_investighiamo", Res.string.exp_title_investighiamo)
  map.put("exp_title_iunu_heliopolis", Res.string.exp_title_iunu_heliopolis)
  map.put("exp_title_l_infinito", Res.string.exp_title_l_infinito)
  map.put("exp_title_la_forma_vso", Res.string.exp_title_la_forma_vso)
  map.put("exp_title_la_frase_misteriosa", Res.string.exp_title_la_frase_misteriosa)
  map.put("exp_title_la_particella_ni", Res.string.exp_title_la_particella_ni)
  map.put("exp_title_la_pazienza_e_finita", Res.string.exp_title_la_pazienza_e_finita)
  map.put("exp_title_la_teoria", Res.string.exp_title_la_teoria)
  map.put("exp_title_le_frasi_avverbiali", Res.string.exp_title_le_frasi_avverbiali)
}
